import { INJECT_UICORE_BUS } from "../../../../lib/utils/consts";

/** @type {UICore.ComponentMeta} */
const ContainerComponentMeta = {
  id: 'w-container',
  name: '纵向内容块',
  category: '布局',
  unpackable: 'default',
  component: {
    name: 'w-container',
    inject: {
      uc: {
        from: INJECT_UICORE_BUS,
        default: null
      }
    },
    props: {
      className: String,
      css: String
    },
    render() {
      var _this$uc;
      const h = arguments[0];
      const isDesignMode = !!((_this$uc = this.uc) !== null && _this$uc !== void 0 && _this$uc.isDesignMode);
      let content = this.$slots.default;
      if (isDesignMode && !content) {
        // 设计模式下，如果容器里没有内容，将展示这个
        content = h("div", {
          "class": "w-container-emptyPlaceholder"
        }, ["\u8BF7\u5728\u8FD9\u91CC\u653E\u7F6E\u7EC4\u4EF6"]);
      }
      return h("div", {
        "class": `w-container uc-slotForBlocks ${this.className} ${!this.$slots.default ? 'isEmpty' : ''}`,
        "style": this.css,
        "ref": "container"
      }, [content]);
    }
  },
  slots: [{
    id: 'default',
    containerRef: 'container'
  }],
  propsSchema: {
    type: 'object',
    fields: [{
      id: 'className',
      type: 'string'
    }, {
      id: 'css',
      title: '自定义CSS',
      type: 'string',
      ui: {
        settings: {
          multipleLine: true
        }
      }
    }]
  }
};
export default ContainerComponentMeta;
//# sourceMappingURL=meta.js.map
